var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Route } from "react-router-dom";
import { redirectToAuthPage } from "./index";
// Маршрут только для авторизованных пользователей. Если пользователь не авторизован, производится редирект на страницу авторизации
var AuthorizedRoute = /** @class */ (function (_super) {
    __extends(AuthorizedRoute, _super);
    function AuthorizedRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthorizedRoute.prototype.render = function () {
        var Component = this.props.component;
        var rest = __assign({}, this.props);
        delete rest.component;
        return React.createElement(Route, __assign({}, rest, { render: function (props) {
                return localStorage.getItem('token') ? React.createElement(Component, __assign({}, props)) : redirectToAuthPage();
            } }));
    };
    return AuthorizedRoute;
}(Component));
export default AuthorizedRoute;
//# sourceMappingURL=AuthorizedRoute.js.map